import { render, staticRenderFns } from "./StrdN_Details.vue?vue&type=template&id=3c5e307f"
import script from "./StrdN_Details.vue?vue&type=script&lang=js"
export * from "./StrdN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports